import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Melody} from "../../model/melody";
import {SubscriberService} from "../../services/subscriber.service";
import {Subscription} from "rxjs";
import {ContentStatus} from "../../model/content-status";
import {AudioService} from "../../services/audio.service";
import {environment} from "../../../environments/environment";

declare var $: any;

@Component({
  selector: '[app-melody-item-slider]',
  templateUrl: './melody-item-slider.component.html',
  styleUrls: ['./melody-item-slider.component.css']
})
export class MelodyItemSliderComponent implements OnInit, OnDestroy {
  @ViewChild("progressBar") private progressBar: ElementRef;
  @Input() melody: Melody;

  purchased: boolean;
  progressBarInitialized = false;

  subscription: Subscription;
  showGiftButton: boolean = environment.showGiftButton;

  constructor(private readonly subscriberService: SubscriberService,
              private audioService: AudioService) {
    this.purchased = false;
    this.progressBarInitialized = false;

    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.subscriberService.subscriberMelodies.subscribe(() => this.checkSubscriberMelodies())
    );

    this.subscription.add(
      this.audioService.getState()
        .subscribe(state => {
          if (state.isPlaying && this.melody.isPlaying) {
            this.initProgressBar();

            if (state.currentTime && state.duration && this.progressBarInitialized) {
              $(this.progressBar.nativeElement).circleProgress('value', Number(state.currentTime) / Number(state.duration));
            }
          } else {
            this.destroyProgressBar();
          }
        })
    );

    this.subscription.add(
      this.subscriberService.favoriteMelodiesIds.subscribe(melodies => {
        if (melodies && this.melody) {
          this.melody.favorite = melodies.filter(melodyId => melodyId == this.melody.id).length > 0;
        }
      })
    );
  }

  play(): void {
    this.audioService.togglePlay(this.melody);
  }

  giftMelody(): void {
    this.subscriberService.giftMelodyPopup(this.melody);
  }

  toggleFavorite(): void {
    this.subscriberService.toggleFavorite(this.melody);
  }

  //TODO Узнать нужно ли передавать событие если пользователь не авторизован, и доработать в соответствии с ТЗ
  purchaseMelody(): void {
    if (!this.purchased) {
      this.subscriberService.purchaseMelodyPopup(this.melody);
    }
  }

  private checkSubscriberMelodies(): void {
    let status = this.subscriberService.getSubscriberMelodyStatus(this.melody.id)
    this.purchased = status == ContentStatus.ACTIVE || status == ContentStatus.ACTIVATING || status == ContentStatus.DEACTIVATING;
  }

  initProgressBar(): void {
    if (!this.progressBarInitialized) {
      $(this.progressBar.nativeElement).circleProgress({
        startAngle: - Math.PI / 2,
        value: 0,
        animation: true,
        size: 57,
        fill: {color: "#191c22"},
        emptyFill: "#ffffff",
        lineCap: 'round',
        strokeLine: 28
      });
      this.progressBarInitialized = true;
    }
  }

  private destroyProgressBar(): void {
    if (this.progressBarInitialized) {
      const progressBar = $(this.progressBar.nativeElement);
      const circleProgress = progressBar.data('circle-progress');
      $(circleProgress.canvas).remove();
      progressBar.removeData('circle-progress');

      this.progressBarInitialized = false;
    }
  }

  ngOnDestroy(): void {
    if (this.melody.isPlaying) {
      this.audioService.stopTrack();
    }
    if (this.progressBarInitialized) {
      this.destroyProgressBar();
    }
    this.subscription.unsubscribe();
  }
}
